import axios from 'axios';
import store from '../store/store';
import router from '../router'
import config from '../config/env';
import { Message } from 'element-ui';
let sent401 = false;

axios.interceptors.request.use(request => {
  const token = store.getters['auth/token'];
  if (token) {
    request.headers.common['Authorization'] = `Bearer ${token}`;
  }

  const locale = store.getters['lang/locale'];
  if (locale) {
    request.headers.common['Accept-Language'] = locale;
  }

  request.url = `${config('APP_URL')}/${request.url}`;
  return request;
});

axios.interceptors.response.use(
  response => {
    if (response.headers.authorization) {
      store.dispatch('auth/saveToken', {
        token: response.headers.authorization.split(' ')[1]
      });
    }
    if (response.data && response.data.message) {
      Message.success({
        message: response.data.message,
        showClose: true,
      });
    }
    if (response.data && response.data.info) {
      Message.info({
        showClose: true,
        message: response.data.info
      });
    }
    sent401 = false;
    return Promise.resolve(response.data);
  },
  error => {
    const { status } = error.response;

    if (status === 401) {
      if (!sent401) {
        Message.error({
          message: 'Lejárt a munkamenet ideje. Lépj be újra.',
          showClose: true,
        });
        sent401 = true;
      }
    } else if (status === 403) {
      Message.error({
        message: 'Nincs jogosultságod a művelet végrahajtásához.',
        showClose: true,
      });
    } else {
      // if (error.response && error.response.data && error.response.data.errors) {
      //   this.errors = error.response.data.errors;
      //   const messages = this.errors.username;
      //   this.$messageWrapper.error({ message: messages.join('\n'), dangerouslyUseHTMLString: true,});
      // }
      let message  = error.response && error.response.data && error.response.data.message || 'Hiba történt a kérés végrehajtása közben.';

      if (
        'arraybuffer' === error.request.responseType &&
        error.response.data instanceof ArrayBuffer
      ) {
        let errorString  = JSON.parse(Buffer.from(error.response.data).toString('utf8'));
        message = errorString && errorString.message || message;
      }

      Message.error({
        message: message,
        showClose: true,
      });
    }

    return Promise.reject(error.response)
  }
);

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
